var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2345 0.177476C10.9183 -0.0900819 10.445 -0.0506457 10.1775 0.265559C9.89087 0.603585 9.60088 0.93875 9.30967 1.27279C8.78117 1.87901 8.06744 2.6858 7.3239 3.49131C6.57798 4.29939 5.81213 5.09519 5.17716 5.6848C5.08047 5.77458 4.35742 6.55231 4.19312 6.46269C4.1047 6.41446 3.98852 6.33273 3.84747 6.21182C3.56549 5.97013 3.25253 5.63152 2.95117 5.26988C2.56879 4.81103 2.2076 4.3312 1.87473 3.83502C1.64726 3.49493 1.17522 3.39848 0.833974 3.62598C0.489328 3.85574 0.396314 4.32157 0.626078 4.66622C0.988257 5.2081 1.38163 5.72951 1.79883 6.23015C2.12247 6.61852 2.49701 7.0299 2.87128 7.35071C3.2554 7.67996 3.7239 8.00002 4.25 8.00002C4.99566 8.00002 5.6934 7.25239 6.19784 6.78399C6.87537 6.15485 7.67202 5.32565 8.4261 4.50873C9.18256 3.68923 9.90633 2.87102 10.4403 2.25849C10.7364 1.91889 11.0312 1.57814 11.3225 1.23447C11.5901 0.918268 11.5507 0.445034 11.2345 0.177476Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/checkWhite.4cdee3c3f5ae9d14726153ac9c96257f.svg";
export { ForwardRef as ReactComponent };